import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'hcon-table-cell',
  template: `<ng-content></ng-content>`,
  styleUrls: ['./table-cell.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableCellComponent {}
